import React, { Component } from 'react';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  saveSolution, SaveCurrentSession, changeSession, updateSession,comparedata,
  EPAActvSolnChange, fetchCompareSolution, fetchMetricsData, fetchCompareMetricsData, exportCompareSolution,getAdvancedSolution,clearGuidance
} from '../../State/actions/sessions';
import { _said } from '../../SizerUI/SizerConfig/Config.js';
import * as Constants from '../../State/constants/CommonConstants';

import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Anchor from 'grommet/components/Anchor';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import TextInput from 'grommet/components/TextInput';
import Table from 'grommet/components/Table';
//import Label from 'grommet/components/Label';
import Layer from 'grommet/components/Layer';
import TableRow from 'grommet/components/TableRow';
// import Image from 'grommet/components/Image';
import Label from 'grommet/components/Label';

import SaveSolutionIcon from 'grommet/components/icons/base/DocumentDownload';
import DirectionsIcon from 'grommet/components/icons/base/Directions';
import AddInfoIcon from 'grommet/components/icons/base/Link';
import ViewIcon from 'grommet/components/icons/base/Bundle';
import FormNextLink from 'grommet/components/icons/base/FormNextLink';
import CloseIcon from 'grommet/components/icons/base/Close';
import RoleIcon from 'grommet/components/icons/base/StreetView';
import SolnIcon from 'grommet/components/icons/base/Info';
import MoneyIcon from 'grommet/components/icons/base/Money';
import ConfigIcon from 'grommet/components/icons/base/Troubleshoot';
import WarningIcon from 'grommet/components/icons/base/Alert';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import MatrixIcon from 'grommet/components/icons/base/Analytics';

import CustomArticle from './CustomArticle';
import RecomSoln from './Recom_Soln';
import BOM from './BOM';
//import CatalogIcon from 'grommet/components/icons/base/Catalog';
//import Compare from './Compare';
import LoadFiles from './LoadFiles';
import ConfigurationDetails from './ConfigurationDetails';
import GraphicalRepresentation from './GraphicalRepresentation';
import MetricsData from './MetricsData';
import MetricsData_vNext from './MetricsData_vNext';
import { said, version } from '../../AppConfig';
import $ from 'jquery';
import { serviceUrl } from '../../AppConfig';
import Select from 'grommet/components/Select';
import SimpleWarning from './SimpleWarning';


//let CompareSolutionFirstCall = false
let MetricsDataFirstClick = false
//let PreviousName = '';
let SolutionAlternativeTabsContent;
let ArraysCount = false;
//var TraditionalArray = [];
var Com = ''
var showDelLayer='';
let CombineRack = [];
var CombineRackSecond = []
var ComputeNodeArray = [];
var ComputeNodeSecondSolArray = [];
var totalNumOfRows = [];
let RolesList = [];
//let dumm = [];
let data = [];
let Note='';
var SavedSolutionname = ''
var compare = ''
let compareSolution1Options = ["Growth - 1Y", "Growth - 2Y", "Growth - 3Y"];
let compareSolution2Options = [];
let compareSolution1value = compareSolution1Options[0];
let compareSolution2value = "Growth - 2Y";
let EPAId = 'EPAvNext';
const BLUE_DATA = "BlueData";
let growthWarning = 'The loaded solution was associated with growth sizing.  To re-generate all 3 solutions, go to the Infrastructure screen and resize.';
const EPA_SOLUTION_ITEMS = ['Elastic Config', 'Growth - 2Y', 'Growth - 3Y', 'Compare Solution'];
const EZMERAL_SOLUTION_ITEMS = ['Elastic Config', 'Growth - 2Y', 'Growth - 3Y', 'Growth - 4Y', 'Compare Solution'];
const NONGROWTH_SOLUTION_ITEMS = ['Elastic Config', 'Compare Solution'];
const GROWTH_4Y = "Growth - 4Y";
const OLDWL_TEXT="The workload inputs are for older version of SAPHANA Appliance, please review and update the workload inputs to build new SAPHANA Appliance solution";
class SolnAlternative extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSaveSolution: false, showDupSoLPopup: false, SessionName: '', CurrentSession: {},
      SolutionObj: '', RoleObj: '', RoleItems: '', SharedRoleObj: '', SharedRoleItems: '',
      activeTab: 0, ServQty: 0, HomePageJson: [], AdditionalInfoPop: false,
      GRPresent: false, GRPresentStatic: false, MetricsDataPresent: false,
      ActiveSoln: null, ActiveSolTabClass: '', RackItem: '', showDelSession:true,
      activeSoltab: 0, ComapareSolState: false, compareSolutionTabactive: false, CloseErrorLayer: false,
      flag: false,header1:'',dropDownState:false

    }
    this.GrClose = this.GrClose.bind(this);

    this.ClosePopup = this.ClosePopup.bind(this);
    this.SessionTxtChange = this.SessionTxtChange.bind(this);
    this.SaveSolution = this.SaveSolution.bind(this);
    this.ShowDelSession = this.ShowDelSession.bind(this);
    this.onSaveSolutionSubmit = this.onSaveSolutionSubmit.bind(this);
    this.onSaveSolutionIconClick = this.onSaveSolutionIconClick.bind(this);
    this.Submit_Update_Session = this.Submit_Update_Session.bind(this);
    this.OverrideSolMsgYesClick = this.OverrideSolMsgYesClick.bind(this);
    this.OverrideSolMsgNoClick = this.OverrideSolMsgNoClick.bind(this);
    this.MetricsDataBtnClick = this.MetricsDataBtnClick.bind(this);
    this.MetricsDataClose = this.MetricsDataClose.bind(this);
    this.GrPresentation = this.GrPresentation.bind(this);
    this.GrPresentationStatic = this.GrPresentationStatic.bind(this);
    this.downloadFiles = this.downloadFiles.bind(this);
    this.updateSolutionTreeView = this.updateSolutionTreeView.bind(this);
    this.SelectActiveSolutionTab = this.SelectActiveSolutionTab.bind(this);
    this.CompareSolution = this.CompareSolution.bind(this);
    this._handleOnPaste = this._handleOnPaste.bind(this);
    this.compareSolnMethod = this.compareSolnMethod.bind(this); 
    this.CloseDelSession = this.CloseDelSession.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onStartGuidance = this.onStartGuidance.bind(this);  }
  handleClose() {
    Com = ''
    this.setState({ flag: false })
  }
  SaveSolname(value,id) {
    SavedSolutionname = value;
    let compareSolutionObj = {
      SavedSolutionName:value,
      selectedselection:id
    };
    this.props.SavedSolname(compareSolutionObj)
    compareSolution2value = value;
    this.props.activeSession.selectedTitles.compareSolution2value = value;
  }
  compareSolnMethod(e,isfromBrowse) {
        
    if (this.props.activeSession.EPAArray.length > 0 && !isfromBrowse) {
    let value;
     if(this.props.activeSession.SavedSolname && this.props.activeSession.SavedSolname.SavedSol === compareSolution2value){
      value = {
        "SessionID": this.props.activeSession.id,
        "SessionIDsaved": this.props.activeSession.SavedSolname.savedId,
        "EPASolutionType" : compareSolution1value.split('-')[1].trim()[0]
      };
     } 
      else {
      let solutionType = compareSolution1value.split('-')[1].trim()[0];
      solutionType += ':'
      solutionType += compareSolution2value.split('-')[1].trim()[0];      
      value = {
        "SessionID": this.props.activeSession.id,
        "EPASolutionType": solutionType
      }
      //this.SaveSolname(compareSolution2value);
    }    
    this.props.OnComparedata(value);

    } else {
      this.state.flag = true;
      compareSolution2value = 'Growth - 1Y';
      Com = <Layer margin="none" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
          <LoadFiles title={"Solution"} onClose={this.handleClose} flag={this.state.flag} Savedname={this.SaveSolname.bind(this)} solutionIndex={isfromBrowse ? compareSolution1value.split('-')[1].trim()[0] : null} />
        </Layer>

    }

    this.props.activeSession.selectedTitles = {
      compareSolution1value,
      compareSolution2value
    }
    this.setState({ header1: compareSolution1value , dropDownState:false });
  }

  _handleOnPaste(e) {
    e.preventDefault();
  }

  onStartGuidance()
  {
    showDelLayer=''
    var workload = {
      "WorkLoad": {}
    };
    this.props.activeSession.workload = JSON.parse(JSON.stringify(this.props.workload));
    workload.WorkLoad = this.props.activeSession.workload;
    var obj = {
      "Workload": workload,
      "SizerSessionId": this.props.activeSession.id,
      "ReferenceId": 1,
      "isSizerAsEntry": true,
      "GuidanceName":"testName",
      "EPASolutionType":this.props.activeSession.EPAArray.length>0 ? (this.state.ActiveSoln+1).toString() : null
    }

    if (['CS750VirtSizer','SynergySizer',"EPAvNext",'SAPHANA'].indexOf(said)!==-1) { 
        //  this.props.OnToggleSizeButton(false);       
      if (said === 'EPAvNext') {
        obj.Workload.WorkLoad.strSizerName = "EPA vNext Sizing Tool";
      }else if(said==='SAPHANA'){
        let toolName = "SAP HANA Sizing Tool";
        obj.Workload.WorkLoad.strSizerName = toolName;
      } else {
        obj.Workload = obj.Workload.WorkLoad;
      }
        this.props.onGetAdvancedSolution(obj);      
    }
    this.setState({ showDelSession: true});
  }
  ShowDelSession(networkError) {
    showDelLayer = <StartGuidanceLayer errorDisplay={networkError} showDelSession={this.state.showDelSession} CloseDelSession={this.CloseDelSession}  StartGuidance={this.onStartGuidance} sessionsCount={this.props.allSessions.length} /> 
    this.setState({ showDelSession: true});
  }

  SelectActiveSolutionTab(val, id) {

    if (this.state.ActiveSoln !== id) {
      this.state.activeSoltab = id;
      if (this.props.activeSession.EPAArray.length > 0 && val !== "Compare Solution") {
        this.state.ComapareSolState = false;
        this.setState({ ActiveSoln: id })
        id = id + 1;
        if (this.props.activeSession.treeView.Solutions.Solution.SolProfile["@ID"] !== id.toString()) {
          this.state.activeTab = 0;
          this.props.onEPAActvSolnChange({ "actvItem": id });
          RolesList = [];
          totalNumOfRows = [];
          ComputeNodeArray = [];
          //TraditionalArray = [];
          this.state.ComapareSolState = false;
          this.props.activeSession.MultipleSolActiveTab = val;
        }
      } else {
        // RolesList=[];
        // totalNumOfRows= [];
        this.setState({ ActiveSoln: id })
        if (id > 0) {
          this.CompareSolution();
        } else {
          this.state.ComapareSolState = false
        }
        // ComputeNodeArray=[];
        // TraditionalArray=[];   
      }
    }

  }

  CompareSolution() {
    // if (said === 'EPA' || said === 'EPAvNext') {
    //   if (CompareSolutionFirstCall) {
    //     CompareSolutionFirstCall = false
    //     this.props.onFetchCompareSolution({ 'SessionID': this.props.activeSession.id })
    //   }
    // }
    this.setState({ ComapareSolState: true });
  }


  downloadFiles(fileType, said) {


    var sessionObject = this.props.activeSession.id;
    var id;
    switch (said) {
      case 'SAPHANA': id = 'Sap Hana Sizing Tool'; break;
      case 'CS750VirtSizer': id = 'CS750VirtSizer'; break;
      case 'SynergySizer': id = 'SynergySizer'; break;
      case 'EPA': id = 'EPA'; break;
    }

    var mapForm = document.createElement("form");
    mapForm.id = "FormExportBOM";
    mapForm.setAttribute("method", "GET")
    mapForm.setAttribute("action", serviceUrl + "SizingEngine/GenerateOCADocument");

    mapForm.target = "_blank";

    var mapInput1 = document.createElement("input");
    mapInput1.id = "BomHTMLTemp1";
    mapInput1.type = "text";
    mapInput1.name = "format";
    mapInput1.value = fileType;
    mapForm.appendChild(mapInput1);

    var mapInput = document.createElement("input");
    mapInput.id = "BomHTMLTemp";
    mapInput.type = "text";
    mapInput.name = "sessionId";
    mapInput.value = sessionObject.toString();
    mapForm.appendChild(mapInput);

    var mapInput2 = document.createElement("input");
    mapInput2.id = "BomHTMLTemp";
    mapInput2.type = "text";
    mapInput2.name = "said";
    mapInput2.value = id;
    mapForm.appendChild(mapInput2);

    var mapInput3 = document.createElement("input");
    mapInput3.id = "BomHTMLTemp";
    mapInput3.type = "text";
    mapInput3.name = "version";
    mapInput3.value = version;
    mapForm.appendChild(mapInput3);

    document.body.appendChild(mapForm);
    mapForm.submit();
    $("#FormExportBOM").remove();


  }

  componentDidMount() {

    // if( this.props.DefaultInputs.Sizers.Sizer['@name'] === 'SAP HANA Sizing Tool'){
    //     if( this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] === '' ||
    //       this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] === null ){
    //       this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] = '';
    //     }
    // }


    if (said === 'EPA' || said === 'EPAvNext') {
//      CompareSolutionFirstCall = true
      MetricsDataFirstClick = true
      this.state.activeSoltab = parseInt(this.props.activeSession.treeView.Solutions.Solution.SolProfile['@ID'], 10) - 1;
      this.state.ActiveSoln = this.state.activeSoltab;

      //   this.props.onFetchCompareSolution({'SessionID': this.props.activeSession.id}) 

      //   this.props.onFetchMetricsData({'SessionID': this.props.activeSession.id}) 
      //  this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id}) 
    }

    // if ((said === 'EPA' && this.props.activeSession.EPAArray.length > 0) || (said === 'EPAvNext' && this.props.activeSession.EPAArray.length > 0) || (said === 'EPAvNext')) {
    //   this.setState({ ActiveSoln: 'Elastic Config' });
    // }

    this.state.CurrentSession = this.props.activeSession;
    this.state.SessionName = this.props.activeSession.alias;

    if (this.props.activeSession.treeView !== '') {
      this.state.HomePageJson = this.props.DefaultInputs;
      this.updateSolutionTreeView(this.props.activeSession.treeView.Solutions);
      // this.updateSolutionTreeView(CSVirtTreeView.Solutions); 
    }
  }

  updateSolutionTreeView(SolTreeView) {
    this.state.SolutionObj = SolTreeView;
    // this.state.SolutionObj = CSVirtSoln;
    this.state.RoleObj = {};
    this.state.SharedRoleObj = {};
    this.state.RoleItems = this.state.SolutionObj.Solution.Roles.Role;
    this.state.SharedRoleItems = this.state.SolutionObj.Solution.Roles.SharedRole;

    if (said === 'CS750VirtSizer' && (this.props.workload.Workload.UserInputs.WorkloadInputMode === "Simple" && this.props.workload.Workload.UserInputs.ThreePAR === "True" && this.state.SharedRoleItems !== undefined && this.state.SharedRoleItems !== '' && this.state.SharedRoleItems.SAN.StorageBoxes > 2)) {
      ArraysCount = true;
    }
    else {
      ArraysCount = false;
    }

    let ServQty = 0;
    if (Array.isArray(this.state.RoleItems)) {
      this.state.RoleItems.map((roleitem, index) => {
        if (roleitem['@DisplayName'] === undefined || roleitem['@DisplayName'] === '') {
          this.state.RoleObj[roleitem['RoleName']] = roleitem;
          if (roleitem['RoleName'] !== 'HPE ConvergedSystem') {
            if (roleitem['ServerName'] !== undefined && roleitem['ServerName'] !== null) {
              ServQty += parseInt(roleitem['ServerName']['@Qty'], 10);
            }
          }
        } else {
          this.state.RoleObj[roleitem['@DisplayName']] = roleitem;
          if (roleitem['@DisplayName'] !== 'HPE ConvergedSystem') {
            if (roleitem['ServerName'] !== undefined && roleitem['ServerName'] !== null) {
              ServQty += parseInt(roleitem['ServerName']['@Qty'], 10);
            }
          }
        }
      });
    } else {
      if (this.state.RoleItems['@DisplayName'] === undefined || this.state.RoleItems['@DisplayName'] === '') {
        this.state.RoleObj[this.state.RoleItems.RoleName] = this.state.RoleItems;
        if (this.state.RoleItems['RoleName'] !== 'HPE ConvergedSystem') {
          if (this.state.RoleItems.ServerName !== undefined && this.state.RoleItems.ServerName !== null) {
            ServQty += parseInt(this.state.RoleItems.ServerName['@Qty'], 10);
          }
        }
      } else {
        this.state.RoleObj[this.state.RoleItems['@DisplayName']] = this.state.RoleItems;
        if (this.state.RoleItems['@DisplayName'] !== 'HPE ConvergedSystem') {
          if (this.state.RoleItems.ServerName !== undefined && this.state.RoleItems.ServerName !== null) {
            ServQty += parseInt(this.state.RoleItems.ServerName['@Qty'], 10);
          }
        }
      }
    }

    if (this.state.SharedRoleItems !== undefined) {
      // if ( Array.isArray(this.state.SharedRoleItems) ) {
      //     this.state.SharedRoleItems.map((sharedroleitem, index) => {
      //       if(sharedroleitem['@DisplayName'] === undefined || sharedroleitem['@DisplayName'] === ''){
      //         this.state.SharedRoleObj[ sharedroleitem['RoleName'] ] = sharedroleitem;
      //       }else{
      //         this.state.SharedRoleObj[ sharedroleitem['@DisplayName'] ] = sharedroleitem;
      //       }
      //     });
      // }else{
      if (!Array.isArray(this.state.SharedRoleItems)) {
        if (this.state.SharedRoleItems['@DisplayName'] === undefined || this.state.SharedRoleItems['@DisplayName'] === '') {
          this.state.SharedRoleObj[this.state.SharedRoleItems['RoleName']] = this.state.SharedRoleItems;
        } else {
          this.state.SharedRoleObj[this.state.SharedRoleItems['@DisplayName']] = this.state.SharedRoleItems;
        }
      }
      else {
        var temp = [];
        var sharedObj = {};
        this.state.SharedRoleItems.forEach((element) => {
          if (element['@DisplayName'] === undefined || element['@DisplayName'] === '') {
            sharedObj[element['RoleName']] = element;
          } else {
            sharedObj[element['@DisplayName']] = element;
          }

          temp.push(sharedObj);
          sharedObj = {};
        });
        this.state.SharedRoleObj = temp;
      }
      // }
    }
    if (said === 'EPA') {
      this.state.RackItem = this.state.SolutionObj.Solution.RackSelected['@CompDesc'];
    }

    this.setState({ ServQty: ServQty });
  }

  componentWillReceiveProps(nextProps, nextState) {

    if(nextProps.networkError !== this.props.networkError)
    {
      if(nextProps.networkError.isError)
      {
        this.ShowDelSession(nextProps.networkError);
      }
    }


    if (nextProps.activeSession.treeView !== '') {
      if (nextProps.activeSession.treeView !== this.props.activeSession.treeView) {
        if (nextProps.activeSession.treeView !== undefined) {
          this.updateSolutionTreeView(nextProps.activeSession.treeView.Solutions);
        }
        if (nextProps.activeSession.id != this.props.activeSession.id) {
          if (said === 'EPA' || said === 'EPAvNext') {
            this.state.activeSoltab = parseInt(nextProps.activeSession.treeView.Solutions.Solution.SolProfile['@ID'], 10) - 1;
            RolesList = [];
            data = [];
            // dumm = [];
            totalNumOfRows = [];
            ComputeNodeArray = [];
            //TraditionalArray = [];
            this.state.ComapareSolState = false;
            // this.props.activeSession.MultipleSolActiveTab = 'Elastic Config';
            // this.state.ActiveSoln = 'Elastic Config';            
            // if (nextProps.activeSession.treeView.Solutions.Solution.SolProfile['#text'] === 'Elastic Config') {
            //   this.state.activeSoltab = 0;
            //   RolesList = [];
            //   data = [];
            //   // dumm = [];
            //   totalNumOfRows = [];
            //   ComputeNodeArray = [];
            //   TraditionalArray = [];
            //   this.state.ComapareSolState = false;
            //   this.props.activeSession.MultipleSolActiveTab = 'Elastic Config';
            //   this.state.ActiveSoln = 'Elastic Config';
            // }
            // else if (nextProps.activeSession.treeView.Solutions.Solution.SolProfile['#text'] === 'Traditional') {
            //   this.state.activeSoltab = 1;
            //   RolesList = [];
            //   data = [];
            //   // dumm = [];
            //   totalNumOfRows = [];
            //   ComputeNodeArray = [];
            //   TraditionalArray = [];
            //   this.state.ComapareSolState = false;
            //   this.props.activeSession.MultipleSolActiveTab = 'Traditional';
            //   this.state.ActiveSoln = 'Traditional';
            // }
          }
        }

      }
    }


    if (nextProps.OverrideSolMsg.isEnabled) {
      this.state.showSaveSolution = true;
      this.state.showDupSoLPopup = true;
    } else {
      //this.state.showSaveSolution = false;
      this.state.showDupSoLPopup = false;
    }

    if (nextProps.toastNotification.isEnabled) {
      this.state.showSaveSolution = false;
    }

  }

  AdditionalInfo() {
    this.setState({ AdditionalInfoPop: true });
  }
  GrPresentationStatic() {
    this.state.GRPresentStatic = true;
    this.setState({ GRPresent: true, });
  }
  GrPresentation(a) {
    this.state.GRPresentStatic = false;
    this.setState({ GRPresent: true });
  }
  MetricsDataBtnClick() {
    if (MetricsDataFirstClick) {
      let obj={
        'SessionID': this.props.activeSession.id,
        'EPASolutionType':this.props.activeSession.EPAArray.length>0 ? (this.state.ActiveSoln+1).toString() : null
      }
      this.props.onFetchMetricsData(obj);
    }
    this.setState({ MetricsDataPresent: true });
  }
  MetricsDataClose() {
    this.props.onClearCompareMetricsData()

    this.setState({ MetricsDataPresent: false });
  }
  ClosePopup() {
    this.setState({ showSaveSolution: false });
    this.props.onDisableconflicts();
  }
  GrClose() {
    this.setState({ GRPresent: false, GRPresentStatic: false });
  }

  SessionTxtChange(e) {
    if (e.target.value.length <= 25) {
      this.setState({ SessionName: e.target.value });
    }
  }
  Submit_Update_Session() {
    if (this.state.SessionName.trim() !== '') {
      this.state.CurrentSession.alias = this.state.SessionName;
      this.props.onSaveCurrentSession();
      this.props.onUpdateSession(this.state.CurrentSession);
      if (this.props.activeSession.id === this.state.CurrentSession.id) {
        this.props.onChangeSession(this.props.activeSession.id);
      }
      this.setState({ showSaveSolution: false });
    }
  }
  onSaveSolutionIconClick() {
    // PreviousName = this.props.activeSession.alias;
    this.setState({ showSaveSolution: true, SessionName: this.props.activeSession.alias });
  }
  onSaveSolutionSubmit() {
    // this.state.CurrentSession = this.props.activeSession;
    // this.Submit_Update_Session();
    /* Changes by Vinay, changed the position of comparision operations, for CID:10016*/
    if (this.state.SessionName !== null && this.state.SessionName.trim() !== '') {
      var initialCheck = false;
      this.SaveSolution(initialCheck);
    }
  }
  SaveSolution(overrideParam) {
    var sessionObject = {
      "UserId": this.props.UserID,
      // "UserId": this.props.UserID,
      "SizerId": _said,
      "SessionID": this.props.activeSession.id,
      "Alias": this.state.SessionName,
      "Override": overrideParam,
      "ParentAlias": '',
      "SolutionId": this.props.activeSession.EPAArray.length>0 ? (this.state.ActiveSoln+1).toString() : null
      // "ParentAlias": PreviousName
    };
    this.props.onSaveSolution(sessionObject);
  }
  OverrideSolMsgYesClick() {
    this.SaveSolution(true);
    this.state.showSaveSolution = false;
//    PreviousName = '';
    this.setState({ showDupSoLPopup: false });
  }
  OverrideSolMsgNoClick() {
    this.props.onDisableconflicts();
    this.setState({ showDupSoLPopup: false });
  }
  ChangeActvSoln(actvitem) {
    this.props.onEPAActvSolnChange({ "actvItem": actvitem });
    //this.setState({ ActiveSoln: actvitem })
  }
  handleCloseError() {
    compare = ''
    this.props.comparedata.CompareData = null
    this.setState({ CloseErrorLayer: true })
  }
  CloseDelSession(){
    showDelLayer = ''
    this.setState({ showDelSession: true})
    if(this.props.networkError.isError)
    {
      this.props.ClearGuidanceError();
    }
  }
  onExport() {
    let text = {
      Data: {
        input: {
          "content": data,
          "currencyone": '$ ' + this.props.comparedata.CompareData.Solution[1].SolPrice,
          "currencytwo": '$ ' + this.props.comparedata.CompareData.Solution[0].SolPrice,
          "Solution1": this.props.activeSession.alias,
          "Solution2": this.props.activeSession.selectedTitles.compareSolution2value,
          "Rack1": this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"],
          "Rack2": this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]
        }
      }
    }
    //let jsontext=JSON.stringify(text)
    //dumm.push(text)
    this.props.onExportCompaeSolution(text)

  }

  compareSolution12Change = (e) => {
    if(e.target.name === "compareSolution1") {
      compareSolution1value = e.option;
    }
    else if (e.target.name === "compareSolution2") {
      compareSolution2value = e.option;
      if (e.option === "Browse") {
        this.compareSolnMethod(e,true)
      }
    }
    this.setState({dropDownState:true});
  }

  populateStorageVolumes = (tableData) => {
    let StorageVolume = []
    let strVolume = ""
    tableData.map((Volume) => {
      StorageVolume.push(
        Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
      )
    })
    StorageVolume.map((disk, id)=>{
      if( id === StorageVolume.length-1) { 
        strVolume += disk;
      } else {
        strVolume += disk + "   "; 
      }
    })
    return strVolume;
  }

  render() {
    compare = ''
    let SolutionCost = '';
    let countryDetails = '';
    let MultipleSolutionTabs = '';
    if(this.props.activeSession.EPAArray.length > 0 && !this.state.dropDownState)
    {
      if(this.props.activeSession.selectedTitles)
      {
        compareSolution1value = this.props.activeSession.selectedTitles.compareSolution1value;
        compareSolution2value = this.props.activeSession.selectedTitles.compareSolution2value;
      }
    }
    if (said === EPAId && this.props.workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
      if (compareSolution1Options.indexOf(GROWTH_4Y) === -1) {
        compareSolution1Options.push(GROWTH_4Y);
      }
    }
    compareSolution2Options = compareSolution1Options.concat(["Browse"]);
    if(this.props.activeSession.SavedSolname && this.props.activeSession.SavedSolname.savedId)
    {
    compareSolution2Options = compareSolution2Options.concat(this.props.activeSession.SavedSolname.SavedSol);
    }
    compareSolution2Options.splice(compareSolution2Options.indexOf(compareSolution1value),1)
    compareSolution2value = compareSolution2Options.indexOf(compareSolution2value) !== -1 ?compareSolution2value : compareSolution2Options[0];
    if (_said === 'EPAvNext') {
      if (this.props.comparedata !== null && this.props.comparedata !== undefined && (this.props.comparedata.CompareData === 'File Mismatch' || this.props.comparedata.CompareData === 'Different Pricing Region')) {
        this.state.CloseErrorLayer = false
      }
      if (this.props.comparedata !== undefined && this.props.comparedata !== null && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData !== 'File Mismatch' && this.props.comparedata.CompareData !== 'Different Pricing Region') {
        var FirstSolRoles = [];
        var ExtraSeconSolroles = [];
        ComputeNodeArray = [];
        ComputeNodeSecondSolArray = [];
        CombineRack = [];
        CombineRackSecond = [];
        ComputeNodeArray = [];
        ComputeNodeSecondSolArray = [];
        totalNumOfRows = [];
        RolesList = [];
        data = [];
        //dumm = []
        var Type = this.props.workload.UserInputs.Environments.WorkloadType;
        console.log(this.props.comparedata)
        let backgrdclrrack = 'none'
        if (this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"] !== this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"]) {
          backgrdclrrack = '#ffd144'
        }
        else{
          backgrdclrrack = '#fff'
        }
        CombineRack = this.props.comparedata.CompareData.Solution.map(function (val) {
          if (val.RackSelected !== undefined) {
            return <td style={{ backgroundColor: backgrdclrrack }}>{val.RackSelected["@CompDesc"]}</td>
          }
        });
        CombineRackSecond = CombineRack.reverse()
        if (Array.isArray(this.props.comparedata.CompareData.Solution[0].Roles.Role)) {
          this.props.comparedata.CompareData.Solution[0].Roles.Role.map(function (val) {
            let strVolume;
            if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
              val["RoleName"] = "Compute Hosts"
            } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
              val["RoleName"] = "Compute Hosts With GPUs"
            } else if (val["RoleName"] === "Gateway Node") {
              val["RoleName"] = "Gateway Host"
            } else if (val["RoleName"] === "Controller Node") {
              val["RoleName"] = "Controller Host"
            } else if (val["RoleName"] === "Storage : HDFS and HDFS-EC") {
              val["RoleName"] = "Storage : HDFS"
            }
            FirstSolRoles.push(val["RoleName"])
            if (Array.isArray(val.DAS.TableData)) {
              strVolume = this.populateStorageVolumes(val.DAS.TableData)

            } else {
              strVolume = val.DAS.TableData["VolumeName"] + " - " + val.DAS.TableData["DiskQty"] + " X " + val.DAS.TableData["Disk"]
            }
            val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
            if (Type === "BlueData") {
              ComputeNodeArray.push(
                { "Role Name": val["RoleName"] },
                { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                { "Processor": val["ProcessorDetails"] },
                { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                { "Storage": strVolume }
              );
            } else {
              let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
               val.Processor=val.Processor.replace("1P"," ")
              if (val.ServerName["#text"] === "HP Moonshot System") {
                SerName = val.Processor
              }
              ComputeNodeArray.push(
                { "Role Name": val["RoleName"] },
                { "Server Name": SerName },
                { "Processor": val["ProcessorDetails"] },
                { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                { "Storage": strVolume });
                if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                  && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                ComputeNodeArray.push(
                { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }

              );
                }
                else{
                  ComputeNodeSecondSolArray.push(
                    { "CPU Performance (SPECint)": "NA" },
                    { "Storage Throughput (MB/s)": "NA" },
                    { "Storage Read IOPs (IOPs)": "NA" },
                    { "Storage Write IOPs (IOPs)": "NA" },
                    { "CPU Perf/Price (SPECint/$1k)": "NA" },
                    { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                    { "Storage Perf/Price (MB/s per $1k)": "NA" },
                    { "CPU Perf/Watt (SPECint/KW)": "NA" },
                    { "Storage Perf/Watt (MB/s per KW)": "NA" }

                  );
                }
            }

          }.bind(this));
        } else {
          var roleobj = this.props.comparedata.CompareData.Solution[0].Roles.Role
          let StorageVolume = [];
          let strVolume;
          if (roleobj["RoleName"] === "Compute hosts" || roleobj["RoleName"] === "Compute Node") {
            roleobj["RoleName"] = "Compute Hosts"
          } else if (roleobj["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobj["RoleName"] === "GPU Node") {
            roleobj["RoleName"] = "Compute Hosts With GPUs"
          } else if (roleobj["RoleName"] === "Gateway Node") {
            roleobj["RoleName"] = "Gateway Host"
          } else if (roleobj["RoleName"] === "Controller Node") {
            roleobj["RoleName"] = "Controller Host"
          } else if (roleobj["RoleName"] === "Storage : HDFS and HDFS-ECC") {
            roleobj["RoleName"] = "Storage : HDFS"
          }
          FirstSolRoles.push(roleobj["RoleName"])
          if (Array.isArray(roleobj.DAS.TableData)) {
            roleobj.DAS.TableData.map((Volume) => {
              StorageVolume.push(
                Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
              )
            })
            if (StorageVolume[2] !== undefined) {
              strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
            } else {
              strVolume = StorageVolume[0] + "    " + StorageVolume[1]
            }

          } else {
            strVolume = roleobj.DAS.TableData["VolumeName"] + " - " + roleobj.DAS.TableData["DiskQty"] + " X " + roleobj.DAS.TableData["Disk"]
          }
          roleobj["Memory"] = roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
          if (Type === "BlueData") {
            ComputeNodeArray.push(
              { "Role Name": roleobj["RoleName"] },
              { "Server Name": roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"] },
              { "Processor": roleobj["ProcessorDetails"] },
              { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
              // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
              { "Storage": strVolume }
            );
          } else {
            let SerName = roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"]
            roleobj.Processor=roleobj.Processor.replace("1P"," ")
            if (roleobj.ServerName["#text"] === "HP Moonshot System") {
              SerName = roleobj.Processor
            }
            ComputeNodeArray.push(
              { "Role Name": roleobj["RoleName"] },
              { "Server Name": SerName },
              { "Processor": roleobj["ProcessorDetails"] },
              { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
              // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
              { "Storage": strVolume });
              if(roleobj.CPUPerf !== undefined && roleobj.StorageTP !== undefined && roleobj.StorageReadIO !== undefined && roleobj.StorageWriteIO !== undefined && roleobj.CPUPerfPrice !== undefined
                && roleobj.RawStoragePrice !== undefined && roleobj.StoragePerfPrice !== undefined && roleobj.CPUPerfWatt !== undefined && roleobj.StoragePerfWatt !== undefined){
              ComputeNodeArray.push(
              { "CPU Performance (SPECint)": roleobj.CPUPerf["#text"] },
              { "Storage Throughput (MB/s)": roleobj.StorageTP["#text"] },
              { "Storage Read IOPs (IOPs)": roleobj.StorageReadIO["#text"] },
              { "Storage Write IOPs (IOPs)": roleobj.StorageWriteIO["#text"] },
              { "CPU Perf/Price (SPECint/$1k)": roleobj.CPUPerfPrice["#text"] },
              { "Raw Storage capacity/Price (TB/$1k)": roleobj.RawStoragePrice["#text"] },
              { "Storage Perf/Price (MB/s per $1k)": roleobj.StoragePerfPrice["#text"] },
              { "CPU Perf/Watt (SPECint/KW)": roleobj.CPUPerfWatt["#text"] },
              { "Storage Perf/Watt (MB/s per KW)": roleobj.StoragePerfWatt["#text"] }
            );
              }
              else{
                ComputeNodeSecondSolArray.push(
                  { "CPU Performance (SPECint)": "NA" },
                  { "Storage Throughput (MB/s)": "NA" },
                  { "Storage Read IOPs (IOPs)": "NA" },
                  { "Storage Write IOPs (IOPs)": "NA" },
                  { "CPU Perf/Price (SPECint/$1k)": "NA" },
                  { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                  { "Storage Perf/Price (MB/s per $1k)": "NA" },
                  { "CPU Perf/Watt (SPECint/KW)": "NA" },
                  { "Storage Perf/Watt (MB/s per KW)": "NA" }

                );
              }
          }
        }

        var RolnotPrst = false
        FirstSolRoles.filter((rol) => {
          RolnotPrst = false
          if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
            this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
              if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
                val["RoleName"] = "Compute Hosts"
              } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
                val["RoleName"] = "Compute Hosts With GPUs"
              } else if (val["RoleName"] === "Gateway Node") {
                val["RoleName"] = "Gateway Host"
              } else if (val["RoleName"] === "Controller Node") {
                val["RoleName"] = "Controller Host"
              } else if (val["RoleName"] === "Storage : HDFS and HDFS-ECC") {
                val["RoleName"] = "Storage : HDFS"
              }
              if (rol.toLowerCase() === val["RoleName"].toLowerCase()) {
                RolnotPrst = true
                let strVolume;
                if (Array.isArray(val.DAS.TableData)) {
                  strVolume = this.populateStorageVolumes(val.DAS.TableData)
                } else {
                  strVolume = val.DAS.TableData["VolumeName"] + " - " + val.DAS.TableData["DiskQty"] + " X " + val.DAS.TableData["Disk"]
                }
                val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                if (Type === "BlueData") {
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": strVolume }
                  );
                } else {
                  let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
                   val.Processor=val.Processor.replace("1P"," ")
                  if (val.ServerName["#text"] === "HP Moonshot System") {
                    SerName = val.Processor
                  }
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": SerName },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": strVolume });
                    if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                      && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                    ComputeNodeSecondSolArray.push(
                    { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                    { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                    { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                    { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                    { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                    { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                    { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                    { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                    { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }

                  );
                    }
                    else{
                      ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": "NA" },
                        { "Storage Throughput (MB/s)": "NA" },
                        { "Storage Read IOPs (IOPs)": "NA" },
                        { "Storage Write IOPs (IOPs)": "NA" },
                        { "CPU Perf/Price (SPECint/$1k)": "NA" },
                        { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                        { "Storage Perf/Price (MB/s per $1k)": "NA" },
                        { "CPU Perf/Watt (SPECint/KW)": "NA" },
                        { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                      );
                    }
                }
              }
            }.bind(this))
          } else {
            var roleobject = this.props.comparedata.CompareData.Solution[1].Roles.Role
            if (roleobject["RoleName"] === "Compute hosts" || roleobject["RoleName"] === "Compute Node") {
              roleobject["RoleName"] = "Compute Hosts"
            } else if (roleobject["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobject["RoleName"] === "GPU Node") {
              roleobject["RoleName"] = "Compute Hosts With GPUs"
            } else if (roleobject["RoleName"] === "Gateway Node") {
              roleobject["RoleName"] = "Gateway Host"
            } else if (roleobject["RoleName"] === "Controller Node") {
              roleobject["RoleName"] = "Controller Host"
            }
            if (rol.toLowerCase() === roleobject["RoleName"].toLowerCase()) {
              RolnotPrst = true
              let StorageVolume = [];
              let strVolume;
              if (Array.isArray(roleobject.DAS.TableData)) {
                roleobject.DAS.TableData.map((Volume) => {
                  StorageVolume.push(
                    Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
                  )
                })
                if (StorageVolume[2] !== undefined) {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
                } else {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1]
                }
              } else {
                strVolume = roleobject.DAS.TableData["VolumeName"] + " - " + roleobject.DAS.TableData["DiskQty"] + " X " + roleobject.DAS.TableData["Disk"]
              }
              roleobject["Memory"] = roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
              if (Type === "BlueData") {
                ComputeNodeSecondSolArray.push(
                  { "Role Name": roleobject["RoleName"] },
                  { "Server Name": roleobject.ServerName["@Qty"] + " X " + roleobject.ServerName["#text"] },
                  { "Processor": roleobject["ProcessorDetails"] },
                  { "Memory": roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                  { "Storage": strVolume }
                );
              } else {
                 let SerName = roleobject.ServerName["@Qty"] + " X " + roleobject.ServerName["#text"]
                  roleobj.Processor=roleobj.Processor.replace("1P"," ")
                  if (roleobject.ServerName["#text"] === "HP Moonshot System") {
                    SerName = roleobject.Processor
                  }
                ComputeNodeSecondSolArray.push(
                  { "Role Name": roleobject["RoleName"] },
                  { "Server Name": SerName},
                  { "Processor": roleobject["ProcessorDetails"] },
                  { "Memory": roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                  { "Storage": strVolume });
                  if(roleobject.CPUPerf !== undefined && roleobject.StorageTP !== undefined && roleobject.StorageReadIO !== undefined && roleobject.StorageWriteIO !== undefined && roleobject.CPUPerfPrice !== undefined
                    && roleobject.RawStoragePrice !== undefined && roleobject.StoragePerfPrice !== undefined && roleobject.CPUPerfWatt !== undefined && roleobject.StoragePerfWatt !== undefined){
                  ComputeNodeSecondSolArray.push(
                  { "CPU Performance (SPECint)": roleobject.CPUPerf["#text"] },
                  { "Storage Throughput (MB/s)": roleobject.StorageTP["#text"] },
                  { "Storage Read IOPs (IOPs)": roleobject.StorageReadIO["#text"] },
                  { "Storage Write IOPs (IOPs)": roleobject.StorageWriteIO["#text"] },
                  { "CPU Perf/Price (SPECint/$1k)": roleobject.CPUPerfPrice["#text"] },
                  { "Raw Storage capacity/Price (TB/$1k)": roleobject.RawStoragePrice["#text"] },
                  { "Storage Perf/Price (MB/s per $1k)": roleobject.StoragePerfPrice["#text"] },
                  { "CPU Perf/Watt (SPECint/KW)": roleobject.CPUPerfWatt["#text"] },
                  { "Storage Perf/Watt (MB/s per KW)": roleobject.StoragePerfWatt["#text"] }
                );
                    }
                    else{
                      ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": "NA" },
                        { "Storage Throughput (MB/s)": "NA" },
                        { "Storage Read IOPs (IOPs)": "NA" },
                        { "Storage Write IOPs (IOPs)": "NA" },
                        { "CPU Perf/Price (SPECint/$1k)": "NA" },
                        { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                        { "Storage Perf/Price (MB/s per $1k)": "NA" },
                        { "CPU Perf/Watt (SPECint/KW)": "NA" },
                        { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                      );
                    }
              }
            }
          }
          if (!RolnotPrst) {
            if (Type === "BlueData") {
              ComputeNodeSecondSolArray.push(
                { "Role Name": "NA" },
                { "Server Name": "NA" },
                { "Processor": "NA" },
                { "Memory": "NA" },
                // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                { "Storage": "NA" }
              );
            } else {
              ComputeNodeSecondSolArray.push(
                { "Role Name": "NA" },
                { "Server Name": "NA" },
                { "Processor": "NA" },
                { "Memory": "NA" },
                // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                { "Storage": "NA" },
                { "CPU Performance (SPECint)": "NA" },
                { "Storage Throughput (MB/s)": "NA" },
                { "Storage Read IOPs (IOPs)": "NA" },
                { "Storage Write IOPs (IOPs)": "NA" },
                { "CPU Perf/Price (SPECint/$1k)": "NA" },
                { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                { "Storage Perf/Price (MB/s per $1k)": "NA" },
                { "CPU Perf/Watt (SPECint/KW)": "NA" },
                { "Storage Perf/Watt (MB/s per KW)": "NA" }
              );
            }
          }

        });
        FirstSolRoles.filter((rol) => {
          if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
            this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
              if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
                val["RoleName"] = "Compute Hosts"
              } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
                val["RoleName"] = "Compute Hosts With GPUs"
              } else if (val["RoleName"] === "Gateway Node") {
                val["RoleName"] = "Gateway Host"
              } else if (val["RoleName"] === "Controller Node") {
                val["RoleName"] = "Controller Host"
              } else if (val["RoleName"] === "Storage : HDFS and HDFS-ECC") {
                val["RoleName"] = "Storage : HDFS"
              }
              if (FirstSolRoles.indexOf(val["RoleName"]) === -1) {
                if (ExtraSeconSolroles.indexOf(val["RoleName"]) === -1) {
                  ExtraSeconSolroles.push(val["RoleName"])
                }
              }
            })
          } else {
            var roleobject = this.props.comparedata.CompareData.Solution[1].Roles.Role
            if (roleobject["RoleName"] === "Compute hosts" || roleobject["RoleName"] === "Compute Node") {
              roleobject["RoleName"] = "Compute Hosts"
            } else if (roleobject["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobject["RoleName"] === "GPU Node") {
              roleobject["RoleName"] = "Compute Hosts With GPUs"
            } else if (roleobject["RoleName"] === "Gateway Node") {
              roleobject["RoleName"] = "Gateway Host"
            } else if (roleobject["RoleName"] === "Controller Node") {
              roleobject["RoleName"] = "Controller Host"
            }
            if (FirstSolRoles.indexOf(roleobject["RoleName"]) === -1) {
              if (ExtraSeconSolroles.indexOf(roleobject["RoleName"]) === -1) {
                ExtraSeconSolroles.push(roleobject["RoleName"])
              }
            }
          }
        })
        ExtraSeconSolroles.filter((extrarol) => {
          if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
            this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
              if (extrarol.toLowerCase() === val["RoleName"].toLowerCase()) {
                let strVolume;
                if (Array.isArray(val.DAS.TableData)) {
                  strVolume = this.populateStorageVolumes(val.DAS.TableData)
                } else {
                  strVolume = val.DAS["VolumeName"] + " - " + val.DAS["DiskQty"] + " X " + val.DAS["Disk"]
                }
                val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                if (Type === "BlueData") {
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    { "Storage": strVolume }
                  );
                } else {
                  let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
                   val.Processor=val.Processor.replace("1P"," ")
                  if (val.ServerName["#text"] === "HP Moonshot System") {
                    SerName = val.Processor
                  }
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": SerName },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    { "Storage": strVolume });
                    if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                      && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                    ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                    { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                    { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                    { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                    { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                    { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                    { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                    { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                    { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }
                  );
                    }
                    else{
                      ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": "NA" },
                        { "Storage Throughput (MB/s)": "NA" },
                        { "Storage Read IOPs (IOPs)": "NA" },
                        { "Storage Write IOPs (IOPs)": "NA" },
                        { "CPU Perf/Price (SPECint/$1k)": "NA" },
                        { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                        { "Storage Perf/Price (MB/s per $1k)": "NA" },
                        { "CPU Perf/Watt (SPECint/KW)": "NA" },
                        { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                      );
                    }
                }
              }
            }.bind(this))
          } else {
            var roleobj = this.props.comparedata.CompareData.Solution[1].Roles.Role
            if (extrarol.toLowerCase() === roleobj["RoleName"].toLowerCase()) {
              let StorageVolume = [];
              let strVolume;
              if (Array.isArray(roleobj.DAS.TableData)) {
                roleobj.DAS.TableData.map((Volume) => {
                  StorageVolume.push(
                    Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
                  )
                })
                if (StorageVolume[2] !== undefined) {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
                } else {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1]
                }
              } else {
                strVolume = roleobj.DAS["VolumeName"] + " - " + roleobj.DAS["DiskQty"] + " X " + roleobj.DAS["Disk"]
              }
              roleobj["Memory"] = roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
              if (Type === "BlueData") {
                ComputeNodeSecondSolArray.push(
                  { "Role Name": roleobj["RoleName"] },
                  { "Server Name": roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"] },
                  { "Processor": roleobj["ProcessorDetails"] },
                  { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  { "Storage": strVolume }
                );
              }
              else {
                 let SerName = roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"]
                  roleobj.Processor=roleobj.Processor.replace("1P"," ")
                  if (roleobj.ServerName["#text"] === "HP Moonshot System") {
                    SerName = roleobj.Processor
                  }
                ComputeNodeSecondSolArray.push(
                  { "Role Name": roleobj["RoleName"] },
                  { "Server Name": SerName },
                  { "Processor": roleobj["ProcessorDetails"] },
                  { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  { "Storage": strVolume });
                  if(roleobj.CPUPerf !== undefined && roleobj.StorageTP !== undefined && roleobj.StorageReadIO !== undefined && roleobj.StorageWriteIO !== undefined && roleobj.CPUPerfPrice !== undefined
                    && roleobj.RawStoragePrice !== undefined && roleobj.StoragePerfPrice !== undefined && roleobj.CPUPerfWatt !== undefined && roleobj.StoragePerfWatt !== undefined){
                  ComputeNodeSecondSolArray.push( 
                  { "CPU Performance (SPECint)": roleobj.CPUPerf["#text"] },
                  { "Storage Throughput (MB/s)": roleobj.StorageTP["#text"] },
                  { "Storage Read IOPs (IOPs)": roleobj.StorageReadIO["#text"] },
                  { "Storage Write IOPs (IOPs)": roleobj.StorageWriteIO["#text"] },
                  { "CPU Perf/Price (SPECint/$1k)": roleobj.CPUPerfPrice["#text"] },
                  { "Raw Storage capacity/Price (TB/$1k)": roleobj.RawStoragePrice["#text"] },
                  { "Storage Perf/Price (MB/s per $1k)": roleobj.StoragePerfPrice["#text"] },
                  { "CPU Perf/Watt (SPECint/KW)": roleobj.CPUPerfWatt["#text"] },
                  { "Storage Perf/Watt (MB/s per KW)": roleobj.StoragePerfWatt["#text"] }
                );
                    }
                    else{
                      ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": "NA" },
                        { "Storage Throughput (MB/s)": "NA" },
                        { "Storage Read IOPs (IOPs)": "NA" },
                        { "Storage Write IOPs (IOPs)": "NA" },
                        { "CPU Perf/Price (SPECint/$1k)": "NA" },
                        { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                        { "Storage Perf/Price (MB/s per $1k)": "NA" },
                        { "CPU Perf/Watt (SPECint/KW)": "NA" },
                        { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                      );
                    }
              }
            }
          }
        })
        var x = ComputeNodeArray.length;
        var y = ComputeNodeSecondSolArray.length;

        if (x > y) {
          totalNumOfRows.length = x;
        } else {
          totalNumOfRows.length = y;
        }
        var RoleItems = []
        if (Type === "BlueData") {
          RoleItems = ["Role Name", "Server Name", "Processor", "Memory", "Storage"];
        } else {
          RoleItems = ["Role Name", "Server Name", "Processor", "Memory", "Storage", "CPU Performance (SPECint)", "Storage Throughput (MB/s)", "Storage Read IOPs (IOPs)", "Storage Write IOPs (IOPs)", "CPU Perf/Price (SPECint/$1k)", "Raw Storage capacity/Price (TB/$1k)", "Storage Perf/Price (MB/s per $1k)", "CPU Perf/Watt (SPECint/KW)", "Storage Perf/Watt (MB/s per KW)"];
        }

        var countRole = 0;
        for (var i = 0; i < totalNumOfRows.length; i++) {
          var ComputeValue;
          var ComputeValueSecond;
          if (i >= ComputeNodeSecondSolArray.length) {
            ComputeValueSecond = "NA";
          } else {
            ComputeValueSecond = ComputeNodeSecondSolArray[i][RoleItems[countRole]];
          }
          if (i >= ComputeNodeArray.length) {
            ComputeValue = "NA";
          } else {
            ComputeValue = ComputeNodeArray[i][RoleItems[countRole]];
          }
          let textspace = ''
          let textspacetwo = ''
          if (ComputeValueSecond === "NA") {
            textspace = 'center'
          }
          if (ComputeValue === "NA") {
            textspacetwo = 'center'
          }
          var backgrdclr = '#fff'
          if (ComputeValueSecond !== ComputeValue && ComputeValueSecond !== 'NA' && ComputeValue !== 'NA') {
            backgrdclr = '#ffd144'
          }
          else{
            backgrdclr = '#fff'
          }
          RolesList.push(<TableRow>
            <td>{RoleItems[countRole]}</td>
            <td style={{ textAlign: textspace, backgroundColor: backgrdclr }}>{ComputeValueSecond}</td>
            <td style={{ textAlign: textspacetwo, backgroundColor: backgrdclr }}>{ComputeValue}</td>

          </TableRow>
          );
          data.push({
            "role": RoleItems[countRole],
            "computevaluesecond": ComputeValueSecond,
            "computevalue": ComputeValue
          })
          countRole++;
          if (Type === "BlueData") {
            if (countRole == 5) {
              countRole = 0;
            }
          } else {
            if (countRole == 14) {
              countRole = 0;
            }
          }
        }
        var Currencyone = ''
        var Currencytwo = ''
        if (this.props.comparedata.CompareData['@Currency'] === 'UD') {
          Currencyone = '$ ' + this.props.comparedata.CompareData.Solution[1].SolPrice
          Currencytwo = '$ ' + this.props.comparedata.CompareData.Solution[0].SolPrice

        } else {
          Currencyone = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[1].SolPrice
          Currencytwo = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[0].SolPrice
        }
      }
      else if (this.props.comparedata !== null && this.props.comparedata !== undefined && !this.props.isLoading && !this.state.CloseErrorLayer && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData === 'File Mismatch') {
        this.state.CloseErrorLayer = false
        compare = <Layer closer={false} overlayClose={true} >
          <Box margin="none" pad="none" size='medium'>
            <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
              <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                <WarningIcon colorIndex='critical' size='small' />
                <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
              </Box>
              <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.handleCloseError.bind(this)} >
                <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
              </Box>
            </Box>
            <Box direction="row" margin="small" pad={{ between: 'small' }} >
              <Paragraph margin="small" >{'Current solution is configured with different platform. Kindly select the solution with same platform to compare'}</Paragraph>
            </Box>
          </Box>
        </Layer>
      }
      else if (this.props.comparedata !== null && this.props.comparedata !== undefined && !this.props.isLoading && !this.state.CloseErrorLayer && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData === 'Different Pricing Region') {
        this.state.CloseErrorLayer = false
        compare = <Layer closer={false} overlayClose={true} >
          <Box margin="none" pad="none" size='medium'>
            <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
              <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                <WarningIcon colorIndex='critical' size='small' />
                <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
              </Box>
              <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.handleCloseError.bind(this)} >
                <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
              </Box>
            </Box>
            <Box direction="row" margin="small" pad={{ between: 'small' }} >
              <Paragraph margin="small" >{'Current solution is configured with different Price Region. Kindly select the solution with same Price Region to compare'}</Paragraph>
            </Box>
          </Box>
        </Layer>
      }
    }
    if (_said === 'EPAvNext') {

      let SolutionItemsList;
      if (this.props.activeSession.EPAArray.length > 0) {
        if (this.props.workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
          SolutionItemsList = EZMERAL_SOLUTION_ITEMS;
        } else {
          SolutionItemsList = EPA_SOLUTION_ITEMS;
        }
      } else { 
        SolutionItemsList = NONGROWTH_SOLUTION_ITEMS;
      }


      MultipleSolutionTabs = SolutionItemsList.map((val, id) => {
        if (this.state.activeSoltab == id) {
          this.state.ActiveSolTabClass = "MultipleSolTabsClass";
        } else {
          this.state.ActiveSolTabClass = "";
        }
        if (val === 'Elastic Config') {
          val = 'Recommended Solution'
        }
        return (<Anchor primary={false} label={val} plain={true} id={id} className={this.state.ActiveSolTabClass} onClick={(e) => this.SelectActiveSolutionTab(val, id)} style={{ padding: '3.6px 7px', position: 'absolute', left: id * 250 + 'px', textDecoration: 'none', fontSize: '18px' }}></Anchor>);
      })
    } else {
      MultipleSolutionTabs = '';
    }



    if (this.state.SolutionObj !== '') {
      SolutionCost = this.state.SolutionObj.Solution.SolPrice;
      if (Constants.DisplayPrice) {
        countryDetails = this.state.SolutionObj['@PriceList'].split(' ')[0] + " Internet Price [ " + this.state.SolutionObj['@Country'] + " ]";
      }
      else {
        countryDetails = "[ " + this.state.SolutionObj['@Country'] + " ]";
      }
    }
    //Rack

    let Rackitem = '';
    if (said === "EPA") {
      Rackitem = <Box direction='row' pad={{ 'between': 'small' }} style={{ marginLeft: '20px' }}>
        <ViewIcon size="small" />
        <Heading tag='h5' margin='none'>Rack - </Heading>
        <Heading tag='h5' margin='none' >{this.state.RackItem}</Heading>
      </Box>
    }
    let CsvsSolutionSummarycontent = '';
    if (said === "CS750VirtSizer" || said === "SynergySizer") {
      let content = 'The information above is a summary of the key solution components. You may save this solution for future recall by pressing the “Save” button. Press the “Configuration Details” button to generate an HTML page summarizing your workload inputs. That page may also be opened in MS-Word or emailed. See further information on that page.'

      CsvsSolutionSummarycontent = <Box pad={{ 'between': 'small' }} style={{ marginLeft: '12px' }}>
        <Heading tag='h5' margin='none' style={{ color: "red", margin: "0px", maxWidth: '100%' }} >{content}</Heading>
      </Box>
    }
    // let SolutionCost = this.state.SolutionObj.Solution.SolPrice;
    // let PriceListDetails = this.state.SolutionObj['@PriceList'].split(' ')[0]+" Internet Price [ "+this.state.SolutionObj['@Country']+" ]";
    let AdditionalInformation = '';
    let AdditionalList = '';
    var prompt = '';
    let showSaveSolutionContent = null;
    let showDupNameContent = null;
    let OCAPopupContent = '';

    if (this.state.showSaveSolution) {
      showSaveSolutionContent = <Layer className="solutionPopup">
        <Box margin='none' pad='none' size='medium' justify='between' >
          <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={false} >Please name your solution</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.ClosePopup} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="none" pad="small" justify="start" style={{ width: '100%' }}>
            <TextInput onPaste={this._handleOnPaste} value={this.state.SessionName} style={{ width: '80%' }}
              placeHolder='Session Name'
              onDOMChange={this.SessionTxtChange} />
            {this.state.SessionName === '' || this.state.SessionName.trim() === '' ?
              <Button primary={true} icon={<FormNextLink size='small' />} />
              :
              <Button primary={true} icon={<FormNextLink size='small' />}
                onClick={this.onSaveSolutionSubmit} />
            }
          </Box>
        </Box>
      </Layer>
    } else {
      showSaveSolutionContent = ""
    }

    if (this.props.OverrideSolMsg.isEnabled && this.state.showDupSoLPopup) {
      showDupNameContent =
        <Layer className="WarningPopup">
          <Box margin='none' pad='none' size='medium' >
            <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
              <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                <WarningIcon size='small' colorIndex='warning' />
                <Heading tag="h4" strong={false} >Please Confirm</Heading>
              </Box>
            </Box>
            <Box margin="none" pad="small">
              <Heading tag='h6' strong={false} margin='none'>
                {this.props.OverrideSolMsg.msg}
              </Heading>
            </Box>
            <Box direction='row' justify='end' margin='none' pad='small'>
              <Button label='Yes' className="SessionOutBtns" onClick={this.OverrideSolMsgYesClick} />
              <Button label='No' className="SessionOutBtns" critical={true} onClick={this.OverrideSolMsgNoClick} />
            </Box>
          </Box>
        </Layer>
    } else {
      showDupNameContent = '';
    }

    if (window.location.pathname.match("/SolnAlternative")) {
      prompt = <Prompt when={false}
        message={location => (
          `Solution will be lost, do you still want to continue ?`
        )}
        />
    } else {
      prompt = <Prompt when={false}
        message={location => (
          `Solution will be lost, do you still want to continue ?`
        )}
        />;
    }

    if (this.state.OCAPopup) {
      OCAPopupContent = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <CircleInformation colorIndex='accent-1-t' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Please select</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start"
              onClick={() => this.setState({ OCAPopup: false })} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>

          <Box style={{ margin: '12px 0px 12px 12px' }} pad={{ between: 'small' }} >
            <Anchor primary={true} onClick={() => this.downloadFiles('xml', said)}>Download an XML file</Anchor>
            <Box direction="column" margin="none" pad={{ between: 'small' }} separator="top"  >
              <Anchor style={{ margin: '5px 0px 0px 0px' }} primary={true} onClick={() => this.downloadFiles('xls', said)}>Download an Excel file</Anchor>
              <Paragraph margin='none'>Please perform Save As for the downloaded file in excel application before uploading to OCA Tool, if excel is your choice. </Paragraph>
            </Box>

          </Box>
        </Box>
      </Layer>
    } else {
      OCAPopupContent = '';
    }


    if (this.state.AdditionalInfoPop) {
      AdditionalList = this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc.map(function (val, id) {
        //  <td> {val["Name"]}  </td>
        return (
          <TableRow key={id} >
            <td className='secondary'> <a href={val["Url"]} target="_blank"> {val["Name"]} </a> </td>
          </TableRow>
        );
      });
      AdditionalInformation = <Layer className="AdditionalInflolayer" style={{ width: '50%', height: '50%' }}>
        <Box direction="column" margin="none" pad="none">
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Additional Information</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={() => { this.setState({ AdditionalInfoPop: false }) } } >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag="h6" strong={true} style={{ margin: '4px 0px' }}>Learn More</Heading>
            <Paragraph style={{ margin: '2px 0px', maxWidth: '100%' }}>{this.state.HomePageJson.Sizers.Sizer.AdditionalInformation["@Text"]}</Paragraph>
            <Table style={{ margin: '4px 0px', overflow: 'initial' }} selectable={false}>
              <tbody>
                {AdditionalList}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Layer>
    } else {
      AdditionalInformation = "";
      AdditionalList = '';
    }

    let RoleObjContent = null;
    if (this.state.RoleObj !== '') {
      RoleObjContent = Object.keys(this.state.RoleObj).map(function (key, index) {

        if (this.state.RoleObj[key].ServerName === undefined) {
          return (<Box key={index} pad={{ between: 'small' }} margin='none' justify='between' >
            <Box direction='row' pad={{ between: 'small' }} colorIndex='light-2' style={{ padding: '5px 10px' }} >
              <RoleIcon size='small' colorIndex='#69506f' />
              <Heading tag='h4' strong={true} margin='none' style={{ fontSize: '15px' }}>{key}</Heading>
            </Box>
          </Box>
          )
        } else {
          return (<Box key={index} pad={{ between: 'small' }} margin='none' justify='between' >
            <CustomArticle key={index}
              ArticleBackgroundColor='light-2'
              ContentBackgroundColor='light-1'
              title={key}
              titleIcon={<RoleIcon size='small' colorIndex='#69506f' />}
              content={<RecomSoln RoleData={this.state.RoleObj[key]} WorkloadType={this.props.workload.UserInputs ? this.props.workload.UserInputs.Environments.WorkloadType:'' } />} />
          </Box>
          )
        }
      }.bind(this))
    }

    let SharedRoleObjContent = null;
    if (this.state.SharedRoleObj !== '') {
      if (!Array.isArray(this.state.SharedRoleObj)) {
        SharedRoleObjContent = <Box pad={{ between: 'small' }} margin='none' justify='between' >
          {Object.keys(this.state.SharedRoleObj).map(function (key, index) {
            return (
              <CustomArticle key={index}
                ArticleBackgroundColor='light-2'
                ContentBackgroundColor='light-1'
                title={key}
                titleIcon={<RoleIcon size='small' colorIndex='#69506f' />}
                content={<RecomSoln RoleData={this.state.SharedRoleObj[key]} />} />
            )
          }.bind(this))}
        </Box>
      }
      else {
        SharedRoleObjContent = this.state.SharedRoleObj.map((eachRole) => {
          return (<Box pad={{ between: 'small' }} margin='none' justify='between' >
            {Object.keys(eachRole).map(function (key, index) {
              return (
                <CustomArticle key={index}
                  ArticleBackgroundColor='light-2'
                  ContentBackgroundColor='light-1'
                  title={key}
                  titleIcon={<RoleIcon size='small' colorIndex='#69506f' />}
                  content={<RecomSoln RoleData={eachRole[key]} />} />
              )
            })}
          </Box>
          )
        });
      }
    }

    let sizerSpecificData = null;
    if (this.state.SolutionObj !== undefined && this.state.SolutionObj !== '' && this.state.SolutionObj.Solution.Roles['SizerSpecificData'] != null && this.state.SolutionObj.Solution.Roles['SizerSpecificData'].trim().length > 0)
      sizerSpecificData = this.state.SolutionObj.Solution.Roles['SizerSpecificData'];

    if (this.state.ComapareSolState) {
      let StyleTable = "CompareTable"
      if (Type === "BlueData") {
        StyleTable = "CompareTable"
      }
      else {
        StyleTable = "CompareTableBig"
      }
      let backgrdclrtotal = '#fff'
      if (Currencyone !== Currencytwo && Currencyone !== 'NA' && Currencytwo !== 'NA') {
        backgrdclrtotal = '#ffd144'
        
      }
      else{
        backgrdclrtotal = '#fff'
      }
      // var link = serviceUrl+said+"/ExportCompareSolution?sessionId="+this.props.activeSession.id;
      SolutionAlternativeTabsContent = <Box margin="small"   className="CompareSolutionTable">
        <Box pad={{"between" : "small"}}>
          <Box direction = "row" pad={{"between" : "small"}} justify="center">
            { this.props.activeSession.EPAArray.length > 0 ? <Box direction='row'>            
            <Select name="compareSolution1" value={compareSolution1value} options={compareSolution1Options} onChange={(e)=>{this.compareSolution12Change(e)}} />
            <Select name="compareSolution2" value={compareSolution2value} options={compareSolution2Options} onChange={(e)=>{this.compareSolution12Change(e)}} />
            </Box>:
            <Box pad='small'>Click on Compare button to select the solution to be compared with</Box>}
            <Button  primary={true} label='Compare' onClick={this.compareSolnMethod} />
          </Box>
          <Box style={{ marginLeft:'44%' }}></Box>
        </Box>

        {/* <Box direction='row' pad='small' margin='small' pad={{ 'between': 'small' }} style={{ justifyContent: 'center', height: '60px' }}>
          <label style={{ marginTop: '1%' }}>Click on Add button to select the solution to be compared with</label>
          <Button style={{ backgroundColor: "#01a982", width: "22%", height: '75%' }} primary={false} label={<Label style={{ color: "white" }}>Add Solution</Label>} onClick={this.compareSolnMethod} />
        </Box> */}
        {Currencyone !== undefined ?
          <Box className={StyleTable}>
            <Table>
              <thead>
                <tr>
                  <th style={{ width: '20%' }}> Details</th>
                  <th>{this.props.activeSession.EPAArray.length > 0  ?  this.props.activeSession.selectedTitles.compareSolution1value : 
                      this.props.activeSession.alias}</th>
                  <th>{this.props.activeSession.selectedTitles.compareSolution2value}</th>
                </tr>
              </thead>
              <tbody>
                <TableRow>
                  <td>Rack</td>
                  {CombineRackSecond}
                </TableRow>
                {RolesList}
              </tbody>
              <tfoot>
                <tr>
                  <th> Total</th>
                  <th style={{ textAlign: 'center', backgroundColor: backgrdclrtotal }}>{Currencyone}</th>
                  <th style={{ textAlign: 'center', backgroundColor: backgrdclrtotal }}>{Currencytwo}</th>
                </tr>
              </tfoot>
            </Table>
            <Button label='Export to Excel' primary={true} onClick={this.onExport.bind(this)} style={{ height: '40px', marginTop: '20px', width: '27%' }} />
          </Box>
          : ''}
      </Box>
    } else {
      var RecommendedHeading = 'Solution Recommended'
      if (said === 'EPAvNext') {
        Type = this.props.workload.UserInputs.Environments.WorkloadType;
        RecommendedHeading = "Recommended Solution"
      }
      Note='';
	if(said === "SAPHANA" && this.props.workload.UserInputs.Environments.WorkloadType === "SAPHANA"){
        if(this.props.workload.UserInputs.Environments.isOldWorkload === true || this.props.workload.UserInputs.Environments.isOldWorkload === 'true'){
          Note = <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: 'yellow' }}>
              <WarningIcon size='small' margin='small' type='status' />
      <Label style={{ marginLeft: '10px' }} size='medium' margin='none'>{OLDWL_TEXT}</Label>
          </Box>
        }else{
          Note = ''
        }
      }else{
        Note = ''
      }
      SolutionAlternativeTabsContent =
        <Box margin="none" pad="none">
          <Box justify='between' direction='row' className="SolAlternativeHeadingsec">
            <Heading tag='h4' style={{ color: '#01a982', marginTop: '13px', fontSize: '19px' }} strong={true} margin='none' >Solution Summary</Heading>
            <Box direction='row' justify='between' margin='none' pad={{ between: 'small' }} className="SolAlterNativeGrpBtns">
              {/*{said === 'EPAvNext' ? <Box direction='row'><Button icon={<CatalogIcon size="small" colorIndex='accent-3' />} style={{ marginLeft: '2%' }} onClick={this.compareSolnMethod} >Compare Solution</Button></Box> : ''}                       */}
              <Button primary={false} plain={true} icon={<SaveSolutionIcon size="small" colorIndex='accent-3' />} label='Save Solution' onClick={this.onSaveSolutionIconClick} />
              
              {['CS750VirtSizer',"EPAvNext",'SAPHANA'].indexOf(said)!==-1 ? <Button id="start-guidance" primary={false} plain={true} icon={<DirectionsIcon size="small" colorIndex='accent-3' />} label='Continue to Guidance' onClick={() => this.ShowDelSession(this.props.networkError)} /> : ''}
              {_said === 'EPA' || _said === 'EPAvNext' ?
                <Button primary={false} plain={true} icon={<MatrixIcon size="small" colorIndex='accent-3' />} onClick={this.MetricsDataBtnClick.bind(this)} label='Metrics Data' />
                : null}
              {said === 'SAPHANA' && this.props.workload.UserInputs.Environments.WorkloadType!=='TDI' ? <Button primary={false} plain={true} icon={<AddInfoIcon size="small" colorIndex='accent-3' />} onClick={this.AdditionalInfo.bind(this)} label='Additional Information' /> : null}
              <Button primary={false} plain={true} icon={<ViewIcon size="small" colorIndex='accent-3' />} onClick={this.GrPresentation.bind(this)} label='Solution Layout' />
            </Box>
          </Box>
          <Box margin='none' className="SolalternativeTabsecs" pad="none" style={{ height: '95%' }}>
            <Tabs className="Tabsec"
              style={{ width: '100%', margin: '0px 0' }}
              activeIndex={this.state.activeTab}
              onActive={i => this.setState({ activeTab: i })}
              justify='start' responsive={true} >
              <Tab title={<Box direction='row' margin='none' pad={{ between: 'small' }} >
                <SolnIcon size='small' />
                <Heading tag='h4' margin='none' >{RecommendedHeading}</Heading>
              </Box>} >
                {/*<Box margin="none" pad="none" direction ='row' style={{margin: '5px 0px'}}>                      
                                  <Anchor primary={false} label='Convert to OCA' plain={true} 
                                          onClick={ () => this.setState({ OCAPopup: true }) } />            
                                  <Anchor primary={false} label='Start OCA' style={{marginLeft: '15px'}} plain={true} onClick={()=>{window.open("https://hpe.sharepoint.com/sites/B1/EG/so/eCPQ/CPQProcess/OCA/Pages/OCA.aspx")}}/>
                              </Box>*/}
                <Box pad={{ between: 'small' }} margin='none' style={{ height: '100%' }} >
                  <Box direction='row' justify='between' pad='none' style={{ marginTop: '12px' }} >
                    <Box direction='row' pad={{ 'between': 'small' }}>
                      <Heading tag='h5' margin='none' >Total Server Count :</Heading>
                      <Heading tag='h5' strong={true} margin='none' >{this.state.ServQty}</Heading>
                    </Box>
                    {!Constants.DisplayPrice ? " " :
                      <Box direction='row' pad={{ 'between': 'small' }}>
                        <Heading tag='h5' margin='none' >Solution Cost :</Heading>
                        {this.state.SolutionObj["@Currency"] === 'UD' ?
                          <Heading tag='h5' strong={true} margin='none' >{'$ ' + SolutionCost}</Heading>
                          :
                          <Heading tag='h5' strong={true} margin='none' >{this.state.SolutionObj["@Currency"] + " " + SolutionCost}</Heading>
                        }
                      </Box>}
                    {/*Change by vinay*/}
                    {said === "CS750VirtSizer" || said === "SynergySizer" ? " " : <Heading tag='h5' margin='none' >{countryDetails} </Heading>}
                  </Box>
                  {/* {said === 'SAPHANA' && this.props.workload.UserInputs.Environments.WorkloadType ==='SAPHANA' ?
                    <Heading tag='h5' margin='none' style={{ color: 'red' }} >
                      Note: The price above is the standard worldwide list price. It reflects only the hardware required for your solution but not any partner or customer discounts. Additional services are required for your HANA solution to run.
                                </Heading> : null} */}
                  {Rackitem}
                  { /* Normal RoleObj Content */}
                  {RoleObjContent}

                  { /* SharedRoleObj Content */}
                  {SharedRoleObjContent}
                  <Box style={{ marginLeft: '1%' }}>
                    <Heading tag='h5' margin='none' style={{ color: "black", margin: "0px", maxWidth: '100%' }} >{sizerSpecificData}</Heading>
                  </Box>
                  {CsvsSolutionSummarycontent}
                  <Box pad='small'>
                  {(said === 'CS750VirtSizer' && ((this.props.workload.Workload.UserInputs.Nimble === "True" && this.props.workload.Workload.UserInputs.Nimble_Nodes_Count > 2) || (this.props.workload.Workload.UserInputs.ThreePAR === "True" && (this.props.workload.Workload.UserInputs.StorageArrayCount > 2 || ArraysCount))))
                    ? <Box>
                      <Heading tag='h5' margin='none' style={{ color: "black", margin: "0px", maxWidth: '100%', fontWeight:'600' }} >Note:</Heading>
                       <Paragraph style={{maxWidth:'100%',margin:'0% 0% 0% 3%'}}> More than two arrays configured. Please get solution reviewed.</Paragraph>
                    </Box> : ''}
                    </Box>
                </Box>
              </Tab>
              <Tab title={<Box direction='row' margin='none' pad={{ between: 'small' }} >
                <MoneyIcon size='small' />
                <Heading tag='h4' margin='none' >BOM Details</Heading>
              </Box>}>
                <Box margin='none' pad='none' align='center' justify='between' >
                  <BOM actvSoln={this.props.activeSession.EPAArray.length > 0 ? this.state.ActiveSoln+1 : null} />
                </Box>
              </Tab>
              <Tab title={<Box direction='row' margin='none' pad={{ between: 'small' }} >
                <ConfigIcon size='small' />
                <Heading tag='h4' margin='none' >Configuration Details</Heading>
              </Box>}>
                <Box margin='none' pad='none' align='center' justify='between' >
                  <ConfigurationDetails actvSoln={this.props.activeSession.EPAArray.length > 0 ? this.state.ActiveSoln+1 : null} />
                </Box>
              </Tab>
            </Tabs>
          </Box>
        </Box>
    }
    var MutpleSolPresnt = [];
    //if(this.props.activeSession.EPAArray.length){
    if (_said === 'EPAvNext') {
      MutpleSolPresnt.push(
        <Box direction='row'  margin="none" pad="none" style={{ height: '35px' , paddingBottom:'35px', borderBottom: '1px solid #614767' }}>
          {MultipleSolutionTabs}
        </Box>);
    }
    let metricsComponent = null;

    if (this.state.MetricsDataPresent && said === 'EPA') {
      metricsComponent = <Layer className="MetricsDataPage" closer={true} flush={false}
        onClose={this.MetricsDataClose} style={{ zIndex: 101 }}>
        <MetricsData />
      </Layer>
    }
    else if (this.state.MetricsDataPresent && said === 'EPAvNext') {
      metricsComponent = <Layer className="MetricsDataPage" closer={true} flush={false}
        onClose={this.MetricsDataClose} style={{ zIndex: 101 }}>
        <MetricsData_vNext />
      </Layer>
    }
    
    let showGrowthWarning;
    if (said === EPAId && this.props.activeSession.EPAArray.length === 0 && this.props.workload.UserInputs.Environments.Growth) {
      let growthServices = this.props.workload.UserInputs.Environments.Growth.Service;
      if (this.props.workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
        growthServices = this.props.workload.UserInputs.Environments.Growth.Host;
      }
      showGrowthWarning = Array.isArray(growthServices) && growthServices.reduce((acc, item) => {
        let growth = parseInt(item['@GrowthRate'], 10);
        if (!isNaN(growth)) {
          return acc + growth;
        }
      }, 0) > 0 ? true : false;
    }

    return (
      <Box pad='none' margin='none' style={{ width: '100%', position: 'relative', margin: '12px 24px 24px 24px' }}>
        {prompt}
        {AdditionalInformation}
        {OCAPopupContent}
        {showSaveSolutionContent}
        {showDelLayer}
        {this.state.GRPresent ?
          <Layer className="GRPage" closer={true} flush={false}
            onClose={this.GrClose} style={{ zIndex: 101 }}>
            <GraphicalRepresentation listItem={this.state.GRPresentStatic} actvSoln={this.state.ActiveSoln+1} />
          </Layer>
          : null
          //<Button primary={false} plain={true} icon={<ViewIcon size="small" colorIndex='accent-3'/>} label='GR Demo' onClick={this.GrPresentationStatic}/>  

        }
        { /*this.state.MetricsDataPresent ?
          <Layer className="MetricsDataPage" closer={true} flush={false} 
                 onClose={this.MetricsDataClose} style={{zIndex:101}}>
                  <MetricsData />
          </Layer>
        : null
        // <Button primary={false} plain={true} icon={<ViewIcon size="small" colorIndex='accent-3'/>} label='GR Demo' onClick={this.GrPresentationStatic}/>                
        */}
        {metricsComponent}

        {showDupNameContent}
        {showGrowthWarning ?
          <SimpleWarning message={growthWarning} /> : ''}
        {MutpleSolPresnt}
        {Note}

        {SolutionAlternativeTabsContent}
        {Com}
        {compare}
      </Box>
    );
  }
}

class StartGuidanceLayer extends Component {

  render(){
    var showDelSession;
    if (this.props.showDelSession) {
      showDelSession = <Layer>
        <Box margin='none' pad='none' size='large' >
          <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon size='small' colorIndex='warning' />
              <Heading tag="h4" strong={false} >{this.props.errorDisplay.isError  ? 'Error':'Please Confirm'}</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.props.CloseDelSession} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box margin="none" pad="small" >
            {this.props.errorDisplay.isError ? 
            <Box>
             <Box>
              <b>{this.props.errorDisplay.msg}</b>
             </Box>
             <Paragraph direction='row'>Please login and request for access at <Anchor id='backToSSETyes' href={this.props.errorDisplay.ssetUrl}>HPE SSET</Anchor>, if you have not done yet.</Paragraph>
          </Box>
              :
              <Heading tag='h6' strong={false} margin='none'> 
            <b>{this.props.errorDisplay.isError>1 ? "Your unsaved workloads will be discarded.":''} <br/>
            You will be directed to SSET guidance for further guidance with this solution. Do you want to continue?</b></Heading>}
          </Box>
          <Box direction='row' justify='end' margin='none' pad='small'>
            {this.props.errorDisplay.isError ? '' : <Button label='Yes' className="SessionOutBtns" onClick={this.props.StartGuidance} />}
            <Button label={this.props.errorDisplay.isError?'Close':'No'} className="SessionOutBtns" critical={this.props.errorDisplay.isError?false:true} onClick={ this.props.CloseDelSession} />
          </Box>
        </Box>
      </Layer>
    } else if(!this.props.showDelSession){
      showDelSession = ""
    }

    return(
      <Box>
        {showDelSession}
      </Box>
    );
    }
}

const mapStateToProps = (state) => {
  return {
    allSessions: state.sessions.sessions,
    activeSession: state.sessions.activeSession,
    DefaultInputs: state.sessions.sessionDefaults.inputs,
    OverrideSolMsg: state.sessions.overrideSolMsg,
    toastNotification: state.sessions.notificationMsg,
    UserID: state.auth.userData.email,
    workload: state.sizerWorkload.workload,
    CompareMetricsData: state.sessions.activeSession.CompareMetricsData,
    //comparedata: state.sessions.CompareData,
    comparedata: state.sessions.activeSession.CompareData,
    networkError:state.sessions.networkError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSaveSolution: (sessionID) => {
      dispatch(saveSolution(sessionID));
    },
    onSaveCurrentSession: () => {
      dispatch(SaveCurrentSession());
    },
    onUpdateSession: (session) => {
      dispatch(updateSession(session))
    },
    onChangeSession: (id) => {
      dispatch(changeSession(id));
    },
    onDisableconflicts: () => {
      dispatch({ type: 'DISMISS_CONFLICTS' })
    },
    onFetchMetricsData: (obj) => {
      dispatch(fetchMetricsData(obj));
    },
    onFetchCompareMetricsData: (obj) => {
      dispatch(fetchCompareMetricsData(obj));
    },
    onFetchCompareSolution: (obj) => {
      dispatch(fetchCompareSolution(obj));
    },
    onEPAActvSolnChange: (obj) => {
      dispatch(EPAActvSolnChange(obj));
    },
    onClearCompareMetricsData: () => {
      dispatch({ type: 'CLEAR_COMPARE_METRICS' });
    },
    SavedSolname: (value) => {
      dispatch({ type: 'SAVEDSOL_NAME', payload: value });
    },    
    onGetAdvancedSolution: (workload) => {
      dispatch(getAdvancedSolution(workload))
    },
    onExportCompaeSolution: (text) => {
      dispatch(exportCompareSolution(text));
    },
    ClearGuidanceError:()=>{
      dispatch(clearGuidance());
    },
    OnComparedata: (value) => {
      dispatch(comparedata(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SolnAlternative);




// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/SolnAlternative.js